"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TShirtSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M11.5,4 L11.6212678,4.01492875 L15.6212678,5.01492875 C15.8801953,5.07966062 16.042633,5.33634469 15.9902903,5.59805807 L15.4902903,8.09805807 C15.4361344,8.36883794 15.1727218,8.54444631 14.9019419,8.49029034 L13,8.10990195 L13,8.10990195 L13,14 C13,14.5522847 12.5522847,15 12,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,8.10990195 L5,8.10990195 L3.09805807,8.49029034 C2.82727819,8.54444631 2.56386564,8.36883794 2.50970966,8.09805807 L2.00970966,5.59805807 C1.95736699,5.33634469 2.11980473,5.07966062 2.37873219,5.01492875 L6.37873219,4.01492875 L6.37873219,4.01492875 L6.5,4 L11.5,4 Z M9,7 C7.72720645,7 6.63954154,6.20737008 6.20368706,5.08879203 L3.08379009,5.86944068 L3.39223227,7.41165159 L6,6.89009805 L6,14 L12,14 L12,6.89009805 L14.6077677,7.41165159 L14.9162099,5.86944068 L11.7962664,5.08891143 C11.3603811,6.20742648 10.2727483,7 9,7 Z M10.7327215,4.99950564 L7.26760632,5.00007248 C7.61342606,5.59783388 8.25974756,6 9,6 C9.7404864,6 10.3869825,5.59757962 10.7327215,4.99950564 Z" })));
};
TShirtSmall.displayName = 'TShirtSmall';
exports.default = TShirtSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TShirtSmall.js.map